<template>
    <el-dialog
            v-if="video"
            :title="video.name"
            :visible.sync="modalVisible"
            width="50%"
            :lock-scroll="true"
            @closed="clearPreview"
            custom-class="tw-py-0"
            top="10vh"
            append-to-body
    >
        <video controls autoplay v-if="video" id="video-preview">
            <source :src="video.video" type="video/mp4" v-if="video">
        </video>
        <div slot="footer" class="tw-flex tw-justify-start">
            <button class="btn btn-link" @click="modalVisible = false">Close</button>
        </div>
    </el-dialog>
</template>
<script>
    import {Dialog} from 'element-ui';

    export default {
        name: "VideoPreview",
        components: {
            'el-dialog': Dialog
        },
        computed: {
            modalVisible: {
                get() {
                    return this.visible;
                },
                set() {
                    this.$emit('closed')
                }
            }
        },
        props: {
            visible: {type: Boolean, required: true},
            video: {type: Object, required: false}
        },
        methods: {
            clearPreview() {
                let videoElement = document.getElementById('video-preview');
                videoElement.pause();
                videoElement.removeAttribute('src');
                videoElement.load();
            },
        }
    }
</script>


<style scoped>
    #video-preview {
        width: 100%;
        max-height: 70vh;
        margin: 0 auto;
        display: block;
    }
</style>